import { computed, ref, type Ref } from "vue";
import { formatAddress } from "./formatAddress";
import type { ContactListItem } from "./types";

export type Query = {
  search: string;
  status:
    | null
    | "isHouseSpeaker"
    | "isPotentialCoreActivist"
    | "hasNoInterestInBecomingActive";
};

export function useFilter(contacts: Ref<Array<ContactListItem> | undefined>) {
  const query: Ref<Query> = ref({
    search: "",
    status: null,
  });

  const filteredContacts = computed(() => {
    if (contacts.value === undefined) return [];

    const normalizedQuery = query.value.search.trim().toLowerCase();

    return contacts.value.filter((contact) => {
      const searchMatched =
        contact.name.toLowerCase().includes(normalizedQuery) ||
        formatAddress(contact.address, contact.apartment)
          .toLowerCase()
          .includes(normalizedQuery) ||
        contact.phoneNumber?.toLowerCase().includes(normalizedQuery) ||
        contact.createdByUsername?.toLowerCase().includes(normalizedQuery);

      const statusMatched =
        (query.value.status === "isHouseSpeaker" && contact.isHouseSpeaker) ||
        (query.value.status === "isPotentialCoreActivist" &&
          contact.isPotentialCoreActivist) ||
        (query.value.status === "hasNoInterestInBecomingActive" &&
          contact.hasNoInterestInBecomingActive) ||
        query.value.status === null;

      return searchMatched && statusMatched;
    });
  });

  return { query, filteredContacts };
}
